export default {
  Empty: "empty",
  Started: "started",
  Completed: "completed"
};



// WEBPACK FOOTER //
// ./src/components/Schemas/EntryStatus.js